import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import SignUpOnInviteAcceptUI from './SignUpOnInviteAcceptUI.js'

class SignUpOnInviteAcceptSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      submitted: false,
      // name
      firstName: this.props.firstName,
      lastName: this.props.lastName,
      firstNameError: null,
      lastNameError: null,
      // password
      password: '',
      passwordError: null,
    }
  }

  render() {
    return (
      <SignUpOnInviteAcceptUI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // name
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        onFirstNameChange={(event) => {this.setState({firstName: event.target.value})}}
        onLastNameChange={(event) => {this.setState({lastName: event.target.value})}}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        setFirstNameError={(error) => {this.setState({firstNameError: error})}}
        setLastNameError={(error) => {this.setState({lastNameError: error})}}
        // password
        password={this.state.password}
        onPasswordChange={(event) => {this.setState({password: event.target.value})}}
        passwordError={this.state.passwordError}
        setPasswordError={(error) => {this.setState({passwordError: error})}}
        // email, accountName
        accountName={this.props.accountName}
        email={this.props.email}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true})

    RestApiUtils.post(this.props.context,
      `/api/pub/signUpOnAccountInvite`,
      this.onSignUpOnInviteAcceptCallback, {
        userId: this.props.userId,
        accountId: this.props.accountId,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        password: this.state.password,
      }
    )
  }

  onSignUpOnInviteAcceptCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'firstName':
            this.setState({firstNameError: error.message})
            break;
          case 'lastName':
            this.setState({lastNameError: error.message})
            break;
          case 'password':
            this.setState({passwordError: error.message})
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    if (errorList.length === 0) {
      this.props.context.onLogin(response.session)
    }
  }

  getMessages(context) {
    let arr = [
      'c_name',
      'c_first_name',
      'c_last_name',
      'c_password',
      'c_sign_up',
      'c_invitation_accepted',
      'c_acct_inv_acpt_signup',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pub_signup_on_invite', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default SignUpOnInviteAcceptSF
